import React from 'react';

import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';

const KycOfakimDocsList = (props) => {
    return (
        <ModalComponent isIconClose onCloseIconClick={props.onCloseClick}>
            <HeaderPanel title={props.title} />
            {Array.isArray(props.docs?.acceptableDocuments) &&
                props.docs.acceptableDocuments.map((el, index) => {
                    return (
                        <Row indent="adaptive-16-24" key={`li_${index}`}>
                            <Panel onClick={(e) => props.onClick(e, el)} isBordered hasBorderRadius isHoverable>
                                <Text>{el.title}</Text>
                            </Panel>
                        </Row>
                    );
                })}
        </ModalComponent>
    );
};

export default KycOfakimDocsList;
